import { VinValidationError } from "./../enums/vinValidationError";

export class VinService {

    static VIN_VALID_LENGTH: number = 17;

    static validateVinCode(value: string): VinValidationError {
        if (value.length != this.VIN_VALID_LENGTH) {
            return VinValidationError.ERROR_INVALID_LENGTH;
        }

        const regex = /^[a-z0-9]+$/i;
        if (!regex.test(value)) {
            return VinValidationError.ERROR_INVALID_FORMAT;
        }
    }
}